import * as React from 'react';
import { text } from '../common/text';
import '../styles/SchoolNotFoundHint.css';

export const SchoolNotFoundHint = () => {
  return (
    <div id="school-move-banner">
      <div className="banner-inner">
        <h2>{text('LBL_SCHOOL_NOT_FOUND_HEADER')}</h2>
        <div className="steps-box">
          <p>{text('LBL_SCHOOL_NOT_FOUND_HINT')}:</p>
          <ol>
            <li>{text('LBL_SCHOOL_NOT_FOUND_STEP_1')}</li>
            <li>{text('LBL_SCHOOL_NOT_FOUND_STEP_2')}</li>
          </ol>
        </div>
        <p className="tip">
          <strong>{text('LBL_SCHOOL_NOT_FOUND_TIP')}:</strong> {text('LBL_SCHOOL_NOT_FOUND_TIP_1')}<br />
          <span className="hint" dangerouslySetInnerHTML={{__html: text('LBL_SCHOOL_NOT_FOUND_TIP_2')}} />
        </p>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/SchoolNotFoundHint.tsx